import React, { useEffect, useRef, useState, useContext } from "react";
import { Col, Container, Row } from "react-bootstrap";
import "./AllCategory.css";
import { Link } from "react-router-dom";

import { Context } from "../../../utils/context";
import { allCategory } from "../../../utils/apis/master/Master";

const AllCategory = ({ data }) => {
  // useEffect(() => {
  //     AOS.init({ once: true });
  // }, []);

  const { IMG_URL } = useContext(Context);

  return (
    <>
      <section className="all-category-home">
        <div className="container-fluid custom_container">
          <Row>
            <Col
              xxl={4}
              xl={4}
              lg={4}
              md={4}
              className="p-1 main_grid_img_holder my-auto"
            >
              <Row>
                <Col xxl={6} xl={6} lg={6} md={6} className="p-1 my-auto">
                  <div className="main_img_holder">
                    {data?.[5] && (
                      // <Link to={`/all-category/${data[5].id}`}>
                      <div className="category-div cat-seecc-first">
                        <div className="image-holder">
                          {/* <img className='category-image ' src={data?.[0]?.image ? `${IMG_URL}${data[0].image}` : 'default_image_url'} /> */}
                          {data?.[5]?.image ? (
                            <img
                              className="category-image"
                              src={`${IMG_URL}${data[5].image}`}
                              alt="Category"
                            />
                          ) : null}
                        </div>
                        {/* <div className='text-holder'>
                                                    <p>{data?.[5]?.name || 'Default Name'}</p>
                                                </div>
                                                <div className='overlay-color'></div> */}
                      </div>
                      // </Link>
                    )}
                  </div>
                </Col>
                <Col xxl={6} xl={6} lg={6} md={6} className="p-1  my-auto">
                  <div className="main_img_holder">
                    {data?.[1] && (
                      // <Link to={`/all-category/${data[1].id}`}>
                      <div className="category-div cat-seecc-second rectangle_shape mb-3">
                        <div className="image-holder ">
                          {data?.[1]?.image ? (
                            <img
                              className="category-image"
                              src={`${IMG_URL}${data[1].image}`}
                              alt="Category"
                            />
                          ) : null}
                        </div>
                        {/* <div className='overlay-color'></div>
                                                <div className='text-holder'>
                                                    <p>{data?.[1]?.name || 'Default Name'}</p>
                                                </div> */}
                      </div>
                      // </Link>
                    )}
                    {data?.[3] && (
                      // <Link to={`/all-category/${data[3].id}`}>
                      <div className="category-div">
                        <div className="image-holder">
                          {data?.[3]?.image ? (
                            <img
                              className="category-image"
                              src={`${IMG_URL}${data[3].image}`}
                              alt="Category"
                            />
                          ) : null}
                          {/* <img className='category-image ' src={data?.[3]?.image ? `${IMG_URL}${data[3].image}` : 'default_image_url'} /> */}
                        </div>
                        {/* <div className='overlay-color'></div>
                                                <div className='text-holder'>
                                                    <p>{data?.[3]?.name || 'Default Name'}</p>
                                                </div> */}
                      </div>
                      // </Link>
                    )}
                  </div>
                </Col>
              </Row>
            </Col>

            <Col xxl={4} xl={4} lg={4} md={4}>
              <div className="main_img_holder">
                {data?.[0] && (
                  // <Link to={`/all-category/${data[0].id}`}>
                  <div className="category-div mb-3">
                    <div className="second-div">
                      <div className="image-holder">
                        <img
                          className="category-image image-2"
                          src={
                            data?.[0]?.image
                              ? `${IMG_URL}${data[0].image}`
                              : "default_image_url"
                          }
                          alt="Logo"
                        />
                      </div>
                      {/* <div className='overlay-color'></div>
                                            <div className='text-holder'>
                                                <p>{data?.[0]?.name || 'Default Name'}</p>
                                            </div> */}
                    </div>
                  </div>
                  // </Link>
                )}
              </div>
            </Col>

            <Col
              xxl={4}
              xl={4}
              lg={4}
              md={4}
              className="p-1 main_grid_img_holder  my-auto"
            >
              <Row>
                <Col xxl={6} xl={6} lg={6} md={6} className="p-1 my-auto">
                  <div className="main_img_holder">
                    {data?.[2] && (
                      // <Link to={`/all-category/${data[2].id}`}>
                      <div className="category-div cat-seecc-second mb-3">
                        <div className="image-holder">
                          {data?.[2]?.image ? (
                            <img
                              className="category-image"
                              src={`${IMG_URL}${data[2].image}`}
                              alt="Category"
                            />
                          ) : null}
                          {/* <img className='category-image' src={data?.[4]?.image ? `${IMG_URL}${data[4].image}` : 'default_image_url'} alt="Logo" /> */}
                        </div>
                        {/* <div className='overlay-color'></div>
                                                <div className='text-holder'>
                                                    <p>{data?.[2]?.name }</p>
                                                </div> */}
                      </div>
                      // </Link>
                    )}
                    {data?.[4] && (
                      // <Link to={`/all-category/${data[4].id}`}>
                      <div className="category-div rectangle_shape">
                        <div className="image-holder ">
                          {data?.[4]?.image ? (
                            <img
                              className="category-image"
                              src={`${IMG_URL}${data[4].image}`}
                              alt="Category"
                            />
                          ) : null}
                          {/* <img className='category-image' src={data?.[4]?.image ? `${IMG_URL}${data[5].image}` : 'default_image_url'} alt="Logo" /> */}
                        </div>
                        {/* <div className='overlay-color'></div>
                                                <div className='text-holder'>
                                                    <p>{data?.[4]?.name || 'Default Name'}</p>
                                                </div> */}
                      </div>
                      // </Link>
                    )}
                  </div>
                </Col>
                <Col xxl={6} xl={6} lg={6} md={6} className="p-1 my-auto">
                  <div className="main_img_holder">
                    {data?.[6] && (
                      // <Link to={`/all-category/${data[6].id}`}>
                      <div className="category-div cat-seecc-first">
                        <div className="image-holder">
                          {data?.[6]?.image ? (
                            <img
                              className="category-image"
                              src={`${IMG_URL}${data[6].image}`}
                              alt="Category"
                            />
                          ) : null}
                          {/* <img className='category-image' src={data?.[6]?.image ? `${IMG_URL}${data[6].image}` : 'default_image_url'} alt="Logo" /> */}
                        </div>
                        {/* <div className='overlay-color'></div>
                                                <div className='text-holder'>
                                                    <p>{data?.[6]?.name || 'Default Name'}</p>
                                                </div> */}
                      </div>
                      // </Link>
                    )}
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
      </section>

      <section className="all-category-home-mobile">
        <div className="custom_container">
          <Row>
            {data?.map((val, index) => (
              <Col md={6} xs={6}>
                {/* <Link to={`/all-category/${val.id}`}> */}
                <div className="category-div cat-seecc-second mb-3">
                  <div className="image-holder">
                    <img
                      className="category-image"
                      src={IMG_URL + val?.image}
                      alt="Logo"
                    />
                  </div>
                  {/* <div className='overlay-color'></div>
                                    <div className='text-holder'>
                                        <p>{val?.name}</p>
                                    </div> */}
                </div>
                {/* </Link> */}
              </Col>
            ))}
            {/* <Col md={6} xs={6}>
                            <div className='category-div cat-seecc-second mb-3'>
                                <div className='image-holder'>
                                    <img className='category-image' src={process.env.PUBLIC_URL + '/assest/image/home/image-2.png'} alt="Logo" />
                                </div>
                                <div className='overlay-color'></div>
                                <div className='text-holder'>
                                    <p>NEW  <br /> HIRING</p>
                                </div>
                            </div>

                        </Col>
                        <Col md={6} xs={6}>
                            <div className='category-div cat-seecc-second mb-3'>
                                <div className='image-holder'>
                                    <img className='category-image' src={process.env.PUBLIC_URL + '/assest/image/home/image-1.png'} alt="Logo" />
                                </div>
                                <div className='overlay-color'></div>
                                <div className='text-holder'>
                                    <p>NEW  <br /> HIRING</p>
                                </div>
                            </div>

                        </Col>
                        <Col md={6} xs={6}>
                            <div className='category-div cat-seecc-second mb-3'>
                                <div className='image-holder'>
                                    <img className='category-image' src={process.env.PUBLIC_URL + '/assest/image/home/image-3.png'} alt="Logo" />
                                </div>
                                <div className='overlay-color'></div>
                                <div className='text-holder'>
                                    <p>NEW  <br /> HIRING</p>
                                </div>
                            </div>

                        </Col>
                        <Col md={6} xs={6}>
                            <div className='category-div cat-seecc-second mb-3'>
                                <div className='image-holder'>
                                    <img className='category-image' src={process.env.PUBLIC_URL + '/assest/image/home/image-4.png'} alt="Logo" />
                                </div>
                                <div className='overlay-color'></div>
                                <div className='text-holder'>
                                    <p>NEW  <br /> HIRING</p>
                                </div>
                            </div>

                        </Col> */}
          </Row>
        </div>
      </section>
    </>
  );
};

export default AllCategory;
